/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Buscar',
  search_no_results_1: '¡Vaya!',
  search_no_results_2: 'No se encontró ese emoji',
  pick: 'Elija un emoji...',
  add_custom: 'Añadir un emoji personalizado',
  categories_activity: 'Actividad',
  categories_custom: 'Personalizado',
  categories_flags: 'Banderas',
  categories_foods: 'Comida y bebida',
  categories_frequent: 'Usado frecuente',
  categories_nature: 'Animales y naturaleza',
  categories_objects: 'Objetos',
  categories_people: 'Emoticonos y personas',
  categories_places: 'Viajes y lugares',
  categories_search: 'Resultados de búsqueda',
  categories_symbols: 'Símbolos',
  skins_choose: 'Elija el tono de piel predeterminado',
  skins_1: 'Predeterminado',
  skins_2: 'Claro',
  skins_3: 'Medio claro',
  skins_4: 'Medio',
  skins_5: 'Medio oscuro',
  skins_6: 'Oscuro',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
